import { render, staticRenderFns } from "./SpecialistAvailabilityMenu.vue?vue&type=template&id=b81444f4"
import script from "./SpecialistAvailabilityMenu.vue?vue&type=script&lang=js"
export * from "./SpecialistAvailabilityMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports